import React, {useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import 'simplebar-react/dist/simplebar.min.css';
import {Welcome} from './Welcome';
import {SlideData} from './SlideData';
import {updateAnswerData} from '../store/reducers/questionReducer';
import ChatAnimationSplit from './ChatAnimationSplit';
import {updateAnswer} from '../services/api';
import {toast, ToastContainer} from 'react-toastify';
import willKnightAnsCircleImage from "../assets/images/willknight-ans-circle-img.jpg";
import allisonHornAnsCircleImage from "../assets/images/allisonhorn-ans-circle-img.jpg";
import paulGoldingCircleImage from "../assets/images/paul-golding-ans-circle-img.jpg";
import nicolasBaratteCircleImage from "../assets/images/nicolas-baratte-ans-circle-img.jpg";
import cherryMaCircleImage from "../assets/images/cherryma-ans-circle-img.jpg";
import smithCodioCircleImage from "../assets/images/smithcodio-ans-circle-img.jpg";
import frederickHavemeyerCircleImage from "../assets/images/frederick-havemeyer-ans-circle-img.jpg";
import rajivChandranCircleImage from "../assets/images/rajivchandran-ans-circle-img.jpg";
import jonGordonCircleImage from "../assets/images/jongordon-ans-circle-img.jpg";
import liorLavidCircleImage from "../assets/images/liorlavid-ans-circle-img.jpg";
import danaKochCircleImage from "../assets/images/danakoch-ans-circle-img.jpg";
import johnGoodyerCircleImage from "../assets/images/johngoodyer-ans-circle-img.jpg";
import simonHollandCircleImage from "../assets/images/simonholland-ans-circle-img.jpg";
import jessMajekodunmiCircleImage from "../assets/images/jessmajekodunmi-ans-circle-img.jpg";
import philipMoyerCircleImage from "../assets/images/philipmoyer-ans-circle-img.jpg";
import reidHoffmanCircleImage from "../assets/images/reidhoffman-ans-circle-img.jpg";
import drCamilleKandikoHowsonCircleImage from "../assets/images/drcamillekandikohowson-ans-circle-img.jpg";
import kathyChenCircleImage from "../assets/images/kathychen-ans-circle-img.jpg";
import tierneyMorganCircleImage from "../assets/images/tierneymorgan-ans-circle-img.jpg";
import bobGerardCircleImage from "../assets/images/bobgerard-ans-circle-img.jpg";

import ethanLawsonCircleImage from "../assets/images/ethan-lawson.png";
import sophiaMartinezCircleImage from "../assets/images/sophia-martinez.png";
import edoSegalCircleImage from "../assets/images/edo-segal.png";
import johnSamuelCircleImage from "../assets/images/john-samuel.png";
import isabellaWongCircleImage from "../assets/images/isabella-wong.png";
import susanGoodyerCircleImage from "../assets/images/susangoodyer-ans-circle-img.jpg";
import bartClarysseCircleImage from "../assets/images/bart-clarysse-ans-circle-img.jpg";
import omarMerloCircleImage from "../assets/images/omar-merlo-ans-circle-img.jpg";
import markKennedyCircleImage from "../assets/images/mark-kennedy-avatarimg.jpg";


import 'react-toastify/dist/ReactToastify.css';

// import ChatAnimationSplit from './ChatAnimationSplit';

interface IProps {
}

interface CacheRequest {
    cogcache_cache_entry_id?: string | null,
    question: string,
    answer: string,
    profile_path: string
}

export const Chat = (props: IProps) => {
    const dispatch = useDispatch();
    const chatAnswers = useSelector((state: any) => state.questionReducer.chatAnswers);
    const computingAnswer = useSelector((state: any) => state.questionReducer.computingAnswer);
    const welcome = useSelector((state: any) => state.questionReducer.welcome);
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);
    const showExperience = useSelector((state: any) => state.questionReducer.showExperience);
    const isOwner = useSelector((state: any) => state.questionReducer.isOwner);
    const slideData = useSelector((state: any) => state.questionReducer.slideData);
    const generating = useSelector((state: any) => state.questionReducer.generating);
    const messagesEndRef = React.useRef<any>(null);
    const [chatAnswersFormatted, setChatAnswersFormatted] = React.useState<any>(chatAnswers);
    const [editIndex, setEditIndex] = React.useState<null | number>(null);

    const counter = React.useRef(0);


    React.useEffect(() => {
        let chatAnswersNew = [...chatAnswers];
        if (chatAnswers.length > 0 && chatAnswers[chatAnswers.length - 1].type === 'myself') {
            chatAnswersNew.push({
                "query": chatAnswers[chatAnswers.length - 1].query,
                "answer": "",
                "status": "Success",
                "cogcache_cache_entry_id": null,
                "question_uid": chatAnswers[chatAnswers.length - 1].question_uid,
                "response_type": "profile-question"
            });
        }
        setChatAnswersFormatted(chatAnswersNew);
    }, [chatAnswers])

    React.useEffect(() => {
        setTimeout(scrollToBottom);
    }, [chatAnswersFormatted])

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({behavior: "smooth"})
    }
    const message = useMemo(() => {
        return computingAnswer;
    }, [computingAnswer])

    const editAnswer = (index: number, cache_entry_id: string) => {
        setEditIndex(index);
    }

    const saveAnswer = (index: number) => {
        const editedData = (document as any).getElementById('tc-answer-text-container-' + index).innerText;
        //update api call
        let data = chatAnswers[index];
        let requestData: CacheRequest = {question: data.query, answer: editedData, profile_path: profilePath};
        if (data && data.cogcache_cache_entry_id) {
            requestData.cogcache_cache_entry_id = data.cogcache_cache_entry_id
        }
        updateAnswer(requestData).then((result: any) => {
            if (result.data.success) {
                toast.success("Answer updated.", {
                    position: "top-center",
                    autoClose: 3000
                });
            }
        });

        //After update
        const updateData = {index: index, answer: editedData};
        dispatch(updateAnswerData(updateData));

        setEditIndex(null);

    }
    const page = (window as any).page ? (window as any).page : 'profile';
    let socialAvatar = '';
    if (page === 'social') {
        if (profilePath === 'will-knight') {
            socialAvatar = willKnightAnsCircleImage;
        }
        if (profilePath === 'allisonhorn') {
            socialAvatar = allisonHornAnsCircleImage;
        }
        if (profilePath === 'paulgolding') {
            socialAvatar = paulGoldingCircleImage;
        }
        if (profilePath === 'nicolasbaratte') {
            socialAvatar = nicolasBaratteCircleImage;
        }
        if (profilePath === 'cherryma') {
            socialAvatar = cherryMaCircleImage;
        }
        if (profilePath === 'frederickhavemeyer') {
            socialAvatar = frederickHavemeyerCircleImage;
        }
        if (profilePath === 'rajivchandran') {
            socialAvatar = rajivChandranCircleImage;
        }
        if (profilePath === 'smithcodio') {
            socialAvatar = smithCodioCircleImage;
        }
        if (profilePath === 'jongordon') {
            socialAvatar = jonGordonCircleImage;
        }
        if (profilePath === 'liorlavid') {
            socialAvatar = liorLavidCircleImage;
        }
        if (profilePath === 'danakoch') {
            socialAvatar = danaKochCircleImage;
        }
        if (profilePath === 'johngoodyer') {
            socialAvatar = johnGoodyerCircleImage;
        }
        if (profilePath === 'simonholland') {
            socialAvatar = simonHollandCircleImage;
        }
        if (profilePath === 'jessmajekodunmi') {
            socialAvatar = jessMajekodunmiCircleImage;
        }
        if (profilePath === 'philipmoyer') {
            socialAvatar = philipMoyerCircleImage;
        }
        if (profilePath === 'reidhoffman') {
            socialAvatar = reidHoffmanCircleImage;
        }
        if (profilePath === 'drcamillekandikohowson') {
            socialAvatar = drCamilleKandikoHowsonCircleImage;
        }
        if (profilePath === 'kathychen') {
            socialAvatar = kathyChenCircleImage;
        }
        if (profilePath === 'tierneymorgan') {
            socialAvatar = tierneyMorganCircleImage;
        }
        if (profilePath === 'bobgerard') {
            socialAvatar = bobGerardCircleImage;
        }

        if (profilePath === 'edosegal') {
            socialAvatar = edoSegalCircleImage;
        }

        if (profilePath === 'john-samuel') {
            socialAvatar = johnSamuelCircleImage;
        }

        if (profilePath === 'isabella-wong') {
            socialAvatar = isabellaWongCircleImage;
        }

        if (profilePath === 'sophia-martinez') {
            socialAvatar = sophiaMartinezCircleImage;
        }

        if (profilePath === 'ethan-lawson') {
            socialAvatar = ethanLawsonCircleImage;
        }

        if (profilePath === 'susangoodyer') {
            socialAvatar = susanGoodyerCircleImage;
        }

        if (profilePath === 'bartclarysse') {
            socialAvatar = bartClarysseCircleImage;
        }

        if (profilePath === 'omarmerlo') {
            socialAvatar = omarMerloCircleImage;
        }

        if (profilePath === 'markkennedy') {
            socialAvatar = markKennedyCircleImage;
        }
    }

    return (
        <div className="tc-chat-inner_wrapper" id='tc-chat-inner_wrapper'>
            <ToastContainer hideProgressBar={true}/>
            <div className="tc-chat-inner-container">
                {(showExperience && chatAnswers.length === 0 && page === 'profile') &&
                    <Welcome welcome={welcome}/>
                }
                {chatAnswersFormatted.map((chat: any, index: number) => {
                    // const minH = (chat.type != 'myself' && (chatAnswers.length == (index + 1)) && computingAnswer.length == 0) ? windowMinHeight : 'auto';
                    const slideDataCheck = slideData.find((x: any) => x.question_uid === chat.question_uid);
                    return (
                        <div
                            className={`${chat.type === 'myself' ? 'tc-chat-msg msg-out' : 'tc-chat-msg msg-in'} ${chatAnswersFormatted.length == (index + 1) ? 'last-message' : ''}`}
                            key={'chat-messages' + index} id={'chat-messages-' + index}
                        >
                            {chat.type === 'myself' ?
                                <span>{chat.answer}</span>
                                :
                                <div className={`${chat.answer == "" ? 'no-opacity' : ''}`}>
                                    {((profilePath === 'edo-segal' || profilePath === 'david' || profilePath === 'david-shrier' || profilePath === 'sky' || profilePath === 'allisonhorn') && slideDataCheck && slideDataCheck.answer?.slide_number > 0) &&
                                        <SlideData slide_number={slideDataCheck.answer.slide_number}/>}
                                    {(generating == chat.question_uid) ?
                                        <div className='tc-answer-wrapper'>
                                            {socialAvatar !== '' && <div className="tc-answer-user-icon">
                                                <img src={socialAvatar}
                                                     alt=""/>
                                            </div>}
                                            <ChatAnimationSplit key={chat.question_uid} identifier={chat.question_uid}
                                                                chatAnswer={chat.answer}
                                                                initialDelay={window.chatOnly ? 0 : 1}
                                                                wordDelay={0.4}
                                                                classNameBeforeDelay={'tc-type-animation-thinking'}
                                                                classNameAfterDelay={''}/>
                                        </div> :
                                        <div className='tc-answer-wrapper'>
                                            {socialAvatar !== '' && <div className="tc-answer-user-icon">
                                                <img src={socialAvatar}
                                                     alt=""/>
                                            </div>}
                                            {index === editIndex ?
                                                <div className={`tc-answer-text-container editable-div`}
                                                     id={`tc-answer-text-container-${index}`}
                                                     contentEditable={'plaintext-only'}>
                                                    {chat.answer}
                                                </div>
                                                :
                                                <div className={`tc-answer-text-container`}>
                                                    {chat.answer.split(' ').map((word: string, wordIndex: number) => (
                                                        <span
                                                            key={wordIndex}
                                                            className={`fade-in-word-completed-class-removed`}
                                                            dangerouslySetInnerHTML={{__html: word.replace(/\n/g, '<br/>') + ' '}}
                                                        >
                                                          
                                                        </span>

                                                    ))}
                                                </div>
                                            }

                                            {editIndex === index && <span className='answer-edit-action-controls'>
                                                <span className='answer-edit-action-item'
                                                      onClick={() => setEditIndex(null)}>
                                                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
                                                            stroke="#ffffff" strokeWidth="2"></path>
                                                        <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                                                              stroke="#ffffff" strokeWidth="2"
                                                              strokeLinecap="round"></path>
                                                    </svg>
                                                </span>
                                                <span className='answer-edit-action-item'
                                                      onClick={() => saveAnswer(index)}>
                                                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                            stroke="#ffffff" strokeWidth="2" strokeLinecap="round"
                                                            strokeLinejoin="round"></path>
                                                        <path d="M7.75 12L10.58 14.83L16.25 9.17004" stroke="#ffffff"
                                                              strokeWidth="2" strokeLinecap="round"
                                                              strokeLinejoin="round"></path>
                                                    </svg>
                                                </span>
                                            </span>}

                                            {(isOwner === true && editIndex !== index) &&
                                                <span className='answer-edit-action-controls'>
                                                    <span className='answer-edit-action-item'
                                                          onClick={() => editAnswer(index, chat.cogcache_cache_entry_id)}>
                                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z"
                                                                  fill="#ffffff"></path>
                                                        </svg>
                                                    </span>
                                                </span>
                                            }
                                        </div>}


                                </div>
                            }
                        </div>

                    )
                })}
                {/*{
                        (computingId != '' && computingAnswer.length === 0) &&
                        <div className='dot-loader' style={{minHeight: windowMinHeight}}>
                            <img src={loadDot} width={80} />
                        </div>
                    }*/}
                {computingAnswer.length > 0 && (<div className={`tc-chat-msg msg-in tc-chat-msg-min-height`}
                                                     key={'chat-messages' + chatAnswersFormatted.length}
                    /*style={{minHeight: windowMinHeight}}*/>
                    {message.map((answer: string) => {
                        return <span className='fade-in-texts'>{answer}</span>;
                    })}
                </div>)}
                <span id='m-chat-scroll-helper-id-chat' ref={messagesEndRef}/>

            </div>

        </div>
    );
}
